const resultFeedback = require("../components/resultFeedback.json");

export function getResponse(string, res) {
  if ((typeof res !== "number" && typeof res !== "string") || String(res).trim() === "" || !Number.isFinite(Number(res))) return "This score is unavailable because the saved answers are incomplete or invalid. It is not a zero score. Please contact EntreMap before repeating the assessment.";
  let result = string.split(".");
  const feedback = resultFeedback[result[0]][result[1]];
  const max = feedback.scale.max;
  const percentage = (res / max) * 100;

  if (percentage >= 80) {
    return feedback.veryHigh || feedback.high;
  }

  if (percentage >= 60) {
    return feedback.high;
  }

  if (percentage >= 40) {
    return feedback.moderate || feedback.medium || feedback.high;
  }

  return feedback.low;
}
